<template>
    <section>
        <navigation></navigation>
        <h5 class="center-align">Profile</h5>

        <div class="card vertical" style="max-width:700px;margin:auto;" v-if="user">
            <div class="card-image" style="margin-top:25px;margin-left:10px;">
                <div class="row">
                    <img
                        v-if="profile.imageLogo"
                        :src="profile.imageLogo"
                        style=" margin-left:auto;margin-right:auto;width:150px;height:150px;border-radius:50%;border:4px solid #333"
                    />
                    <div class="center-align" >
                        <!-- <a class="btn-floating btn-large waves-effect waves-light cyan center-align" style=""><i class="material-icons">cloud_upload</i></a> -->
                        <input type="file" name="uploadfile" @change="processFile($event)" id="img" style="display:none;margin-top:8px;" />
                        <!-- <label for="img" tag="a" class="btn-floating btn-large waves-effect waves-light cyan center-align"><i class="material-icons">cloud_upload</i></label> -->
                        <label id="" for="img" tag="a" class="btn waves-effect waves-light cyan">{{valueButton}}</label>
                        <!-- <a for="img" class="waves-effect waves-light btn" style="margin-left:auto;margin-right:auto;"><i class="material-icons left">edit</i>Change Company Picture</a> -->
                         <!-- <div class = "file-field">
                            <div class = "waves-effect waves-light btn">
                                <span>Browse</span>
                                <input type="file" name="uploadfile" @change="processFile($event)" id="img" style="display:none;margin-top:8px;"/>
                            </div>
                         </div> -->
                        
                    </div>
                     
                </div>
               
                <!-- <img
                    :src="profile.imageLogo"
                    style="width:75px;height:75px;border-radius:50%;border:4px solid #333"
                /> -->
            </div>
            <div class="card-stacked">
                <div class="card-content" style="margin:auto;">
                    <!-- <p> -->
                        <!-- <b>Name:</b>
                        <strong> {{profile.fullName}}</strong>
                        <br /><b>Email:</b>
                        <strong> {{profile.email}}</strong>
                        <br /><b>Company Name:</b>
                        <strong> {{profile.companyName}}</strong>
                        <br /><b>Business Address:</b>
                        <strong> {{profile.businessAddress}}</strong>
                        <br /><b>Phone Number:</b>
                        <strong> {{profile.phoneNumber}}</strong>
                        <br /><b>SEC/DTI Registration:</b>
                        <strong> {{profile.secDtiRegistration}}</strong>
                        <br /><b>TIN Number:</b>
                        <strong> {{profile.tinNumber}}</strong> -->

                        <!-- <br />uid:
                        <strong>{{user.uid}}</strong> -->
                        <!-- <br />provider:
                        <strong class="teal-text">{{user.providerData[0].providerId}}</strong> -->
                    <!-- </p> -->
                    <div class="row" style="margin:auto;">
                        <div class="input-field col s12">
                            <i class="material-icons prefix">account_circle</i>
                            <textarea :value="profile.fullName" id="icon_prefix2" class="materialize-textarea" onkeydown="return false"></textarea>
                            <label class="active" for="icon_prefix2">Name</label>
                        </div>
                    </div>
                    <div class="row" style="margin:auto;">
                         <div class="input-field col s12">
                            <i class="material-icons prefix">mail</i>
                            <textarea :value="profile.email" id="icon_prefix2" class="materialize-textarea" onkeydown="return false"></textarea>
                            <label class="active" for="last_name">Email</label>
                        </div>
                    </div>
                   <div class="row" style="margin:auto;">
                        <div class="input-field col s12">
                            <i class="material-icons prefix">business</i>
                            <textarea :value="profile.companyName" id="icon_prefix2" class="materialize-textarea" onkeydown="return false"></textarea>
                            <label class="active" for="icon_prefix2">Company Name</label>
                        </div>
                    </div>
                    <div class="row" style="margin:auto;">
                        <div class="input-field col s12">
                            <i class="material-icons prefix">location_city</i>
                            <textarea :value="profile.businessAddress" id="icon_prefix2" class="materialize-textarea" onkeydown="return false"></textarea>
                            <label class="active" for="icon_prefix2">Business Address</label>
                        </div>
                    </div>
                    <div class="row" style="margin:auto;">
                        <div class="input-field col s12">
                            <i class="material-icons prefix">perm_identity</i>
                            <textarea :value="profile.secDtiRegistration" id="icon_prefix2" class="materialize-textarea" onkeydown="return false"></textarea>
                            <label class="active" for="icon_prefix2">SEC/DTI Registration</label>
                        </div>
                      
                    </div>
                    <div class="row" style="margin:auto;">
                          <div class="input-field col s12">
                            <i class="material-icons prefix">perm_identity</i>
                            <input :value="profile.tinNumber" id="last_name" type="text" onkeydown="return false">
                            <label class="active" for="last_name">TIN Number</label>
                        </div>
                    </div>
                    <div class="row" style="margin:auto;">
                        <div class="input-field col s12">
                            <i class="material-icons prefix">local_phone</i>
                            <textarea :value="profile.phoneNumber" id="icon_prefix2" class="materialize-textarea" onkeydown="return false"></textarea>
                            <label class="active" for="icon_prefix2">Phone Number</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import navigation from "@/components/NavBar.vue";
import firebase from "firebase";

export default {
    data() {
        return {
            user: null,
            profile: null,
            profileImage:"",
            valueButton:"Upload Company Picture"
        };
    },
    components: {
        navigation
    },
    mounted(){
     $(function() {
        M.updateTextFields();
    });
    $('input').keydown(function(e) {
        e.preventDefault();
        return false;
    });
    },
    created() {
        firebase.auth().onAuthStateChanged(user => {
            if (user) {
                const vm = this;
                this.user = user;
                const cityRef = firebase.firestore().collection('merchants').doc(user.uid);
                cityRef.get().then(function(doc) {
                    if (doc.exists) {
                        vm.profile = doc.data();
                        profileImage = vm.profile.imageLogo;
                        if(doc.data().imageLogo){
                            valueButton = "Change Company Picture";
                        }
                        else{
                            valueButton = "Upload Company Picture";
                        }
                    } 
                }).catch(function(error) {
                    // console.log("Error getting document:", error);
                });
            }
            else{
                $router.push({name:'Home'})
            }
        });
       
    },
    methods:{
        processFile(event) {
            const vm = this;
            this.someData = event.target.files[0];
            this.profileImage = URL.createObjectURL(this.someData);

            var fullPath = event.target.files[0].name;
            if (fullPath) {
            if(fullPath.length>0){
               
                var startIndex = (fullPath.indexOf('\\') >= 0 ? fullPath.lastIndexOf('\\') : fullPath.lastIndexOf('/'));
                var filename = fullPath.substring(startIndex);
                if (filename.indexOf('\\') === 0 || filename.indexOf('/') === 0) {
                    filename = filename.substring(1);
                }
              //alert(filename);
                let task;
                task = firebase
                        .storage()
                        .ref()
                        .child("MerchantProfileImages/" + filename)
                        .put(this.someData);
                var storageRef = firebase.storage().ref();
                this.$$(".progress").show();
                task.then((snapshot) => {
                    snapshot.ref.getDownloadURL().then(function(downloadURL) {
                        // console.log("File available at", downloadURL);
                        vm.profile.imageLogo = downloadURL;
                        var washingtonRef = firebase.firestore().collection('merchants').doc(vm.user.uid);

                        // Set the "capital" field of the city 'DC'
                        return washingtonRef.update({
                            imageLogo: downloadURL
                        })
                        .then(function() {
                            // console.log("Document successfully updated!");
                            vm.$M.toast({ html: "Upload Complete" });
                        })
                        .catch(function(error) {
                            // The document probably doesn't exist.
                            // console.error("Error updating document: ", error);
                        });
                    });
                    
                })
                .catch(error => {
                        this.$M.toast({ html: error.message });
                    })
                    .then(() => {
                        this.$$(".progress").hide();
                    });
            }
            else{
                // alert("wala");
            }
            }
            else{
                // alert("wala talga");
            }
           

            

        }, 
    }
};
</script>
